// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.textField {
  width: 100%;
  padding-bottom: 20px !important;
}

.buttonField {
  width: 100%;
  padding-bottom: 20px !important;
}

.fileUploadField {
  width: 100%;
  padding-bottom: 20px !important;
}

a {
  color: green;
}

.aLink {
  color: red;
  background-color: red;
}
.aLink :hover {
  color: blue;
}

.rootContainer {
  display: flex;
}

.rootContainer > * {
  background-color: white;
  color: black;
  margin-right: 20px;
  font-size: 12px;
}

.downloadButton {
  margin-bottom: 20px !important;
}

.headerText {
  font-size: 20px;
  font-weight: bold;
  padding-bottom: 80px;
  color: rgb(87, 84, 84);
}`, "",{"version":3,"sources":["webpack://./src/components/pages/manager/ViewReimbursements.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,+BAAA;AACJ;;AAGA;EACI,WAAA;EACA,+BAAA;AAAJ;;AAKA;EACI,WAAA;EACA,+BAAA;AAFJ;;AAKA;EACI,YAAA;AAFJ;;AAIA;EACI,UAAA;EACA,qBAAA;AADJ;AAGI;EACI,WAAA;AADR;;AAMA;EACI,aAAA;AAHJ;;AAOA;EAEI,uBAAA;EACA,YAAA;EACA,kBAAA;EAEA,eAAA;AANJ;;AAUA;EACI,8BAAA;AAPJ;;AAYA;EACI,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;AATJ","sourcesContent":[".textField{\n    width:100%;\n    padding-bottom: 20px!important;\n    \n}\n\n.buttonField{\n    width:100%;\n    padding-bottom: 20px!important;\n    \n}\n\n\n.fileUploadField{\n    width:100%;\n    padding-bottom: 20px!important;\n    \n}\na{\n    color:green;\n}\n.aLink{\n    color:red;\n    background-color: red;\n    \n    :hover{\n        color:blue;\n        \n    }\n}\n\n.rootContainer{\n    display: flex;\n    //flex-flow: row  nowrap;\n    \n}\n.rootContainer> * {\n    \n    background-color: white;\n    color: black;\n    margin-right: 20px;\n\n    font-size: 12px;\n    \n}\n\n.downloadButton{\n    margin-bottom:20px!important;\n    \n}\n\n\n.headerText{\n    font-size:20px;\n    font-weight: bold;\n    padding-bottom:80px;\n    color:rgb(87, 84, 84);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
